import React, { useEffect, useState, useContext } from "react";

import {
  Card,
  CardHeader,
  CardBody,
  Stack,
  Button,
  useDisclosure,
  Spinner,
  IconButton,
  FormErrorIcon,
} from "@chakra-ui/react";

import { UserDataContext } from "contexts/UserDataContext";

import SettingsIcon from "@mui/icons-material/Settings";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

import { NavLink, useNavigate } from "react-router-dom";

import SummeryDrawer from "components/SummaryDrawer/SummaryDrawer";

import dashboard_activity_panel_icon from "../assets/images/icons/dashboard_activity_panel_icon.svg";
import useDocumentTitle from "hooks/useDocumentTitle";

import UserDetailService from "../services/UserDetailService";
import GetRecentActivity from "services/GetRecentActivity";

import formatDate from "utils/utils";
import formateDateTime from "utils/formateDateTime";
import GetRecentSupplierUpdates from "services/GetRecentSupplierUpdates";

import monitor_rulebook from "../assets/images/icons/general_icons/monitor_rulebook.png";
import rulebook_summary from "../assets/images/icons/general_icons/rulebook_summary.png";
import info_icon from "../assets/images/icons/info_icon.svg";

import GetCurrentUserSuppliers from "services/GetCurrentUserSuppliers";
import FormErrorMessage from "components/FormErrorMessage/FormErrorMessage";

function Dashboard() {
  const { addUserData: addUserDataContext } = useContext(UserDataContext);

  // use states

  const [userData, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [recentActivity, setRecentActivity] = useState([]);
  const [loadingRecentActivity, setLoadingRecentActivity] = useState(true);

  const [recentSupplierUpdates, setRecentSupplierUpdates] = useState([]);
  const [recentSupplierUpdatesSummaries, setRecentSupplierUpdatesSummaries] =
    useState([]);
  const [loadingRecentSupplierUpdates, setLoadingRecentSupplierUpdates] =
    useState(false);

  const [favSupplierList, setFavSupplierList] = useState([]);
  const [loadingFavouriteSupplier, setLoadingFavouriteSupplier] =
    useState(true);

  const [drawerSupplierId, setDrawerSupplierId] = useState(null);
  const [drawerSummaryText, setDrawerSummaryText] = useState(null);

  const [supplierCount, setSupplierCount] = useState("-");

  // const user = JSON.parse(localStorage.getItem("user"));
  const { isOpen, onOpen, onClose } = useDisclosure();

  const navigate = useNavigate();

  useDocumentTitle("Dashboard");

  useEffect(() => {
    const fetchSupplierCount = async () => {
      const params = {
        page_size: 1,
        page_number: 0,
      };

      try {
        const response = await GetCurrentUserSuppliers(params);
        setSupplierCount(response.data.data);

        setSupplierCount(response.data.total_records);
      } catch (error) {
        console.log(error);
      }
    };

    fetchSupplierCount();
  }, []);

  useEffect(() => {
    const fetchUserDetail = async () => {
      setIsLoading(true);

      try {
        const response_user_data = await UserDetailService();
        setUserData(response_user_data.data.data);
        addUserDataContext(response_user_data.data.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };

    const fetchRecentActivity = async () => {
      setLoadingRecentActivity(true);

      try {
        const response_recent_activity = await GetRecentActivity({
          page_size: 3,
          page_number: 0,
        });
        setRecentActivity(response_recent_activity.data.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoadingRecentActivity(false);
      }
    };

    const fetchRecentSupplierUpdates = async () => {
      setLoadingRecentSupplierUpdates(true);
      try {
        const response = await GetRecentSupplierUpdates();
        setRecentSupplierUpdates(response?.data?.supplier_request_objects);
        setRecentSupplierUpdatesSummaries(
          response?.data?.supplier_request_objects_summaries
        );
      } catch (error) {
        console.log("error", error);
      } finally {
        setLoadingRecentSupplierUpdates(false);
      }
    };

    const fetchFavouriteSupplier = async () => {
      const params = {
        page_size: 10,
        page_number: -1,
        is_favourite: true,
      };

      setLoadingFavouriteSupplier(true);

      try {
        const response = await GetCurrentUserSuppliers(params);
        setFavSupplierList(response.data.data);
      } catch (error) {
        console.log("error", error);
      } finally {
        setLoadingFavouriteSupplier(false);
      }
    };

    fetchFavouriteSupplier();
    fetchUserDetail();
    fetchRecentActivity();
    fetchRecentSupplierUpdates();
  }, []);

  const handleOpenDrawer = (supplierId, summary_text) => {
    setDrawerSupplierId(supplierId);
    setDrawerSummaryText(summary_text);
    onOpen();
  };

  const navigateToSupplierDetail = (data, defaultTab) => {
    navigate(`/user/suppliers/${data.supplier_id}`, {
      state: { data: data, default_tab: defaultTab },
    });
  };

  return (
    <>
      <div className="">
        <Stack spacing={"35px"}>
          {isLoading ? (
            <div>
              <Spinner size="sm" />
            </div>
          ) : (
            <div>
              <h1 className="font-raleway  ">
                Welcome {userData?.first_name}! 👋🏻
              </h1>
            </div>
          )}

          <SummeryDrawer
            isOpen={isOpen}
            onOpen={onOpen}
            onClose={onClose}
            supplierId={drawerSupplierId}
            summaryText={drawerSummaryText}
          />

          {/* {isLoading && <Loading />} */}

          {true && (
            <div className=" w-full h-full flex flex-col xl:flex-row gap-6  ">
              <div className="xl:w-[70%]   flex flex-col gap-6 pl-1 ">
                <Card>
                  <CardHeader>
                    <h2 className="">Recent Supplier Updates</h2>
                    <div className="  secondary-background-accent-color mt-4 py-1 px-2  flex flex-row gap-3 ">
                      <div className="h-full flex flex-col justify-center">
                        <img src={info_icon} alt="information icon" />
                      </div>
                      <p className="secondary-text-accent-color-dark">
                        Discover the latest rulebook changes and summaries from
                        the past 14 days.
                      </p>
                    </div>
                  </CardHeader>
                  <CardBody>
                    {loadingRecentSupplierUpdates && (
                      <div className=" flex flex-row justify-center w-full h-[12.8rem]">
                        <Spinner className="my-auto" size="lg" />
                      </div>
                    )}
                    {!loadingRecentSupplierUpdates && (
                      <div className="overflow-x-auto">
                        {recentSupplierUpdates.length > 0 && (
                          <table className="min-w-full  border primary-border-color max-h-[12.8rem] ">
                            <thead>
                              <tr className="bg-[#e9e9e9] ">
                                <th className="pl-2 py-1.5 table-heading  min-w-56 max-w-60 xl:max-w-xl ">
                                  Name
                                </th>

                                <th className=" py-1.5 table-heading  max-w-3">
                                  Last Updated
                                </th>
                                <th className=" py-1.5 table-heading">
                                  Last Checked
                                </th>
                                <th className="pl-2 py-1.5 table-heading-center ">
                                  Monitor Rulebook
                                </th>
                                <th className="pl-2 py-1.5 table-heading-center ">
                                  View Summary
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {recentSupplierUpdates.map((supplier, index) => (
                                <tr
                                  className="border-b  primary-border-color"
                                  key={index}
                                >
                                  <td className="py-2.5 table-text  min-w-56 max-w-60 xl:max-w-lg  ">
                                    {supplier.supplier.supplier_name}
                                  </td>

                                  <td className=" table-text-light  ">
                                    <p className="table-text-light   ">
                                      {formatDate(
                                        supplier.supplier_request_start_time
                                      )}
                                    </p>
                                  </td>
                                  <td className=" table-text-light  ">
                                    <p className="table-text-light   ">
                                      {formatDate(
                                        supplier?.supplier?.last_checked
                                      )}
                                    </p>
                                  </td>
                                  <td className=" text-center   ">
                                    <Button
                                      variant={"ghost"}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        navigateToSupplierDetail(
                                          supplier.supplier,
                                          1
                                        );
                                      }}
                                    >
                                      <img
                                        src={monitor_rulebook}
                                        alt="tracking icon"
                                      />
                                    </Button>
                                  </td>
                                  <td className="text-center secondary-color-text hover:cursor-pointer  ">
                                    <IconButton
                                      onClick={() =>
                                        handleOpenDrawer(
                                          supplier.supplier_request_id,
                                          recentSupplierUpdatesSummaries[index]
                                        )
                                      }
                                      variant="ghost"
                                      aria-label="View Summary"
                                      icon={
                                        <div className="secondary-color-text">
                                          <img
                                            src={rulebook_summary}
                                            alt="View supplier summary"
                                          />
                                        </div>
                                      }
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                        {recentSupplierUpdates.length === 0 && (
                          <FormErrorMessage
                            errorMsg={
                              "There's no recent activity to display at the moment. Check back later or start exploring to see updates here."
                            }
                            color={"text-gray-400"}
                          />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
                <Card>
                  <CardHeader>
                    <div className="flex flex-row justify-between">
                      <h2 className="font-raleway">Supplier Favorites</h2>
                    </div>
                    <div className="  secondary-background-accent-color mt-4 py-1 px-2  flex flex-row gap-3 ">
                      <div className="h-full flex flex-col justify-center">
                        <img src={info_icon} alt="information icon" />
                      </div>
                      <p className="secondary-text-accent-color-dark">
                        Effortlessly monitor and engage with your favorite
                        suppliers at a glance.
                      </p>
                    </div>
                  </CardHeader>
                  <CardBody>
                    {loadingFavouriteSupplier && (
                      <div className=" flex flex-row justify-center w-full h-[12.8rem]">
                        <Spinner className="my-auto" size="lg" />
                      </div>
                    )}
                    {!loadingFavouriteSupplier && (
                      <div className="overflow-x-auto max-h-[12.8rem] ">
                        {favSupplierList.length > 0 && (
                          <table className="min-w-full  border primary-border-color table-auto ">
                            <thead>
                              <tr className="bg-[#e9e9e9] ">
                                <th className="pl-2 py-1.5 table-heading ">
                                  Name
                                </th>

                                <th className=" py-1.5 table-heading">
                                  Last Updated
                                </th>
                                <th className=" py-1.5 table-heading">
                                  Last Checked
                                </th>
                                <th className="pl-2 py-1.5 table-heading-center ">
                                  Monitor Rulebook
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {favSupplierList?.map((supplier, index) => {
                                let data = supplier.supplier;

                                return (
                                  <tr
                                    className="border-b  primary-border-color hover:bg-gray-100 hover:cursor-pointer group"
                                    onClick={() => {
                                      navigateToSupplierDetail(data, 0);
                                    }}
                                    key={index}
                                  >
                                    <td className="py-2.5 table-text  min-w-56 max-w-60 xl:max-w-lg  ">
                                      {data.supplier_name}
                                    </td>

                                    <td className=" table-text-light  ">
                                      <p className="table-text-light   ">
                                        {formatDate(data.last_modified)}
                                      </p>
                                    </td>

                                    <td className=" table-text-light  ">
                                      <p className="table-text-light   ">
                                        {formatDate(data.last_checked)}
                                      </p>
                                    </td>

                                    <td className=" text-center   ">
                                      <Button
                                        variant={"ghost"}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          e.preventDefault();
                                          navigateToSupplierDetail(
                                            supplier.supplier,
                                            1
                                          );
                                        }}
                                      >
                                        <img
                                          src={monitor_rulebook}
                                          alt="tracking icon"
                                        />
                                      </Button>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        )}
                        {favSupplierList.length === 0 && (
                          <FormErrorMessage
                            errorMsg={
                              "You currently don't have a favorite supplier selected. Visit the Suppliers page to choose your favorite and have them featured here."
                            }
                            color={"text-gray-400"}
                          />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </div>
              <div className="xl:w-[30%]  flex flex-col gap-6 pl-2 pr-2 ">
                <div className="">
                  {isLoading && (
                    <div className="h-[25rem] border primary-border-color flex flex-col justify-center ">
                      <div className="flex flex-row justify-center">
                        <Spinner className="my-auto" size="lg" />
                      </div>
                    </div>
                  )}
                  {!isLoading && (
                    <table className=" w-full table-auto  border primary-border-color bg-white  ">
                      <thead>
                        <tr className="">
                          <th colSpan={"2"} className="px-3 pb-4   pt-6  ">
                            <div className="flex flex-row justify-between ml-2">
                              <h2>Account Overview</h2>
                              <div className="text-[#17bab3]">
                                <AccountCircleIcon />
                              </div>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="border-b h-5  border-gray-300">
                          <td className="pl-4 py-4   ">
                            <p className="table-heading ">Name</p>
                          </td>
                          <td className=" table-text-light  max-w-64 ">
                            <div className="whitespace-normal break-all">
                              {userData?.first_name} {userData?.last_name}
                            </div>
                          </td>
                        </tr>
                        <tr className="border-b  border-gray-300">
                          <td className="pl-4 py-4">
                            <p className="table-heading">Email</p>
                          </td>
                          <td className=" table-text-light">
                            <div className="whitespace-normal break-all">
                              {userData?.user_email}
                            </div>
                          </td>
                        </tr>
                        <tr className="border-b  border-gray-300">
                          <td className="pl-4 py-4">
                            <p className="table-heading">No. of Suppliers</p>
                          </td>
                          <td className=" table-text-light">{supplierCount}</td>
                        </tr>
                        <tr className="border-b   border-gray-300">
                          <td className="pl-4  py-4  ">
                            <p className="table-heading">Activation Date</p>
                          </td>
                          <td className=" py-4 table-text-light">
                            {formatDate(userData?.created_on)}
                          </td>
                        </tr>
                        <tr className="border-b  border-gray-300">
                          <td
                            colSpan={"2"}
                            className="py-10   px-3 table-text    "
                          >
                            <div className="px-8">
                              <NavLink to="/user/profile">
                                <Button size="sm" variant={"outline"}>
                                  <div>
                                    <SettingsIcon />
                                  </div>
                                  <div className="pl-2"> Account Settings</div>
                                </Button>
                              </NavLink>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  )}
                </div>
                <div className="">
                  {loadingRecentActivity && (
                    <div className="h-[15rem] border primary-border-color flex flex-col justify-center ">
                      <div className="flex flex-row justify-center">
                        <Spinner className="my-auto" size="lg" />
                      </div>
                    </div>
                  )}
                  {!loadingRecentActivity && (
                    <table className="border border-gray-300 bg-white w-full table-auto">
                      <thead>
                        <tr>
                          <th
                            colSpan={"2"}
                            className="px-3 pb-1.5 pt-4 break-words"
                          >
                            <div className="ml-2 flex flex-row justify-between">
                              <h2>Recent Activity</h2>
                              <img
                                src={dashboard_activity_panel_icon}
                                alt="activity panel icon"
                              />
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {recentActivity.map((activity, index) => (
                          <tr id={index} className="border-b border-gray-300">
                            <td className=" py-4 table-heading  max-w-52 ">
                              <div className="pl-3 whitespace-normal break-words">
                                {activity?.api?.api_description}
                              </div>
                            </td>
                            <td className="table-text-light">
                              <div className="block whitespace-normal">
                                {formateDateTime(activity?.created_on)}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          )}
        </Stack>
      </div>
    </>
  );
}

export default Dashboard;
